'use strict';
mpangoApp.controller('MeventuserController', MeventuserController);  
function MeventuserController($scope, Mreports,Muser, $window,$http, $auth, $location,$rootScope,$state,$uibModal,Notification,SweetAlert) {
    $scope.isActive = function(route) {
        return route === $location.path();
    };
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num){};
    $scope.$on('$viewContentLoaded', function () {
        Muser.getEventusers().success(function(data,status) {
            $scope.eventusers = data.eventusers;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.initEventrole = function() {
        Muser.getEventusers().success(function(data,status) {
            $scope.eventroles = data.eventroles;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.open = function  (templatename,size) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                eventusers:function  () {
                    return $scope.eventusers;
                }
            },
            controller: function  ($scope,eventusers, $uibModalInstance) {
                $scope.add = function  (userdata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        angular.extend(userdata,{user_id:$scope.currentUser.id});
                        Muser.postUser(userdata).success(function  (data,status) {
                            $scope.eventusers = eventusers;
                            $scope.eventusers.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    };  
                }
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.update = function(userdata,formname,index) {
        if (formname == 'userupdate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Update user data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'activate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Activate user",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'deactivate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Deactivate user",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        $state.reload();
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
        if (formname == 'passreset') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Reset user password",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
                function(isConfirm){ 
                if (isConfirm) {
                    Muser.updateUser(userdata,formname).success(function(data) {
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                 
               } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
               }
            });
        };
    }; 
}
MeventuserController.$inject = ['$scope', 'Mreports','Muser', '$window','$http', '$auth', '$location','$rootScope','$state','$uibModal','Notification','SweetAlert'];